module.exports = __webpack_public_path__ + "img/1_การใช้งานทั่วไป.da5508d7.png";